import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import Select from "react-select";
import FilePreviewer from "../common/file_displayer";

function DepartmentCreation() {
  const [formData, setFormData] = useState({});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [error, setError] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [optionslist, setOptionsList] = useState([]);
  const [selectedOption, setSelectedOption] = useState({value: 'invoice_number', label: 'Invoice Number'});
const [popupData, setPopupData] = useState([]);
const [selectedFile, setSelectedFile] = useState("");
const [gridApi, setGridApi] = useState(null);

const [popupRows, setPopupRows] = useState([]);
const [showPopup, setShowPopup] = useState(false);
const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    initialize();
    fetchStatusColumnTypesList();
  }, []);



const handlePopupRowChange = (index, field, value) => {
  setPopupRows(prevRows => {
    const newRows = [...prevRows];
    newRows[index][field] = value;

    if (field === 'percentage') {
      const perc = parseFloat(value) || 0;
      const poAmt = parseFloat(newRows[index].poAmount) || 0;
      newRows[index].value = ((perc / 100) * poAmt).toFixed(2);
    }

    return newRows;
  });
};

const handleDeleteFile = (filePath, index) => {
 // 1. Prevent deleting the last remaining file
  const nonEmptyFiles = popupData.files.filter(f => f && f.trim() !== "");
  if (nonEmptyFiles.length === 1) {
    alert("At least one file must be present. You cannot delete the last file.");
    return;
  }

  // 2. Ask for confirmation
  const confirmed = window.confirm("Are you sure you want to delete this file?");
  if (!confirmed) {
    return; // user canceled
  }

  // 3. Get file type from extension
  const extension = filePath.split(".").pop().toLowerCase();
  let fileType = "other";
  if (["pdf"].includes(extension)) {
    fileType = "pdf";
  } else if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
    fileType = "image";
  }

  console.log("File to delete:", filePath);
  console.log("Index:", index);
  console.log("Detected type:", fileType);

  // 4. Update state (clear only that index instead of removing all)
  const updatedFiles = [...popupData.files];
  updatedFiles[index] = ""; // mark this slot empty
  setPopupData(prev => ({
    ...prev,
    files: updatedFiles
  }));

  // 5. Prepare backend payload
  const fileset = {
    [`file_${index + 1}_type`]: null,
    [`file_${index + 1}_path`]: null,
  };


    const payload = {
      schema_name: 'payments',
      table: 'adhoc_invoice_details',
      set_column : fileset,
      'where' : [{"id":formData.adhoc_invoice_details_id}]
    };
  console.log("Backend payload:", payload);
    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });

};



  const initialize = async () => {
    try {
      await Promise.all([fetchFieldInfo1()]);
    } catch (err) {
      setError("Initialization failed");
    } finally {
      setLoading(false);
    }
  };

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

const fetchStatusColumnTypesList = () => {
  const dropdownOptions = [
    { label: 'Invoice Number', value: 'invoice_number' },
    { label: 'PO Number', value: 'purchase_order_number' },
    { label: 'Unique Number', value: 'unique_number' }
  ];
  setOptionsList(dropdownOptions);
};

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const fetchFieldInfo1 = async () => {
    const payload = { headerconfig_id: 58, "filterconditions": [] };
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = [
          {
            headerName: '',
            checkboxSelection: true,
            headerCheckboxSelection: true,
            width: 50
          },
          ...data.fields.map((field) => ({
            headerName: formatColumnName(field.columnName),
            field: field.columnName,
            sortable: true,
            filter: true,
            resizable: true,
            width: 300
          })),
        ];
        setColumnDefs(columns);
        setFields(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
  };


const handleFileUpload = async (e, columnName, file_path = '/data/p2p/Production/Projects/TeamLease/PaymentsProcess/Payments/static/assets/files/pdf') => {
  const file = e.target.files[0];
  if (!file) return;

  const sharedFilePath = `${file_path}`; // e.g. "assets/files/pdf/"

  const formData = new FormData();
  formData.append("file", file);
  formData.append("filePath", sharedFilePath);

  try {
    const response = await fetch("http://206.1.17.185:1200/api/v2/user_modules/upload/", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) throw new Error("Upload failed");

    const data = await response.json();
    const backendFileName = data.Filename; // ? backend-sanitized filename

    // Update frontend state
    setPopupData((prev) => {
      const newFiles = [...prev.files];
      const colIndex = parseInt(columnName.replace("file_", "").replace("_path", "")) - 1;
      newFiles[colIndex] = backendFileName; // use backend filename
      return { files: newFiles };
    });

  } catch (error) {
    console.error("Error uploading file:", error);
    alert("File upload failed");
  }
};


const handleCheckboxChange = async(event) => {
  const selectedRows = event.api.getSelectedRows();
  const selectedRow = selectedRows.length > 0 ? selectedRows[0] : null;
  if (!selectedRow) {
    // No row selected � hide popup or reset state
    setShowPopup(false);
    return;
  }
console.log("selectedRow",selectedRow)
  // Check if transaction is locked
    {/*  
  if (selectedRow.is_transaction_locked!== 0) {
    alert(`${selectedRow.working_person_name} is working on this transaction`);
    // return;
  } */}

  // Update state with selected row
  setFormData(selectedRow);
  fetchFileInfo2(selectedRow.adhoc_invoice_details_id)

};

const fetchFileInfo2 = async (id) => {
  const payload = {
    query: `SELECT file_1_path,file_2_path,file_3_path,file_4_path,file_5_path,
                   file_6_path,file_7_path,file_8_path,file_9_path,file_10_path 
            FROM payments.adhoc_invoice_details 
            WHERE id = ${id};`
  };

  try {
    const FileUploadCredentials = Fetchexecutequery();
    const response = await axios.post(
      FileUploadCredentials[1],
      payload,
      FileUploadCredentials[0]
    );

    const data = response.data;

    if (data && data.length > 0) {
      // Convert into array of file paths
      const row = data[0];
      const filePaths = Object.values(row).filter(
        (path) => path && path.trim() !== ""
      );

setPopupData({
  files: Array.from({ length: 10 }, (_, i) => {
    if (filePaths[i]) {
      // Strip the prefix
      return filePaths[i].replace(/^assets\/files\/pdf\//, "");
    }
    return "";
  })
});

      setShowPopup(true);
    }
  } catch (error) {
    console.error("Error fetching department data:", error);
    setError("Error fetching department data");
  }
};


const handleFileSave = () => {
  // Ensure at least one file is uploaded
  const hasFile = popupData.files.some((f) => f && f.trim() !== "");
  if (!hasFile) {
    alert("Please upload at least one file before saving.");
    return;
  }

  // Build payload dynamically
const fileData = {};
let counter = 1; // start from file_1

// Fill sequentially for non-empty files
popupData.files.forEach((file) => {
  if (file && file.trim() !== "" && counter <= 10) {
    const ext = file.split(".").pop().toLowerCase();

    fileData[`file_${counter}_type`] = ext;
    fileData[`file_${counter}_path`] = `assets/files/pdf/${file}`;

    counter++;
  }
});

// Pad remaining slots with null until 10
for (let i = counter; i <= 10; i++) {
  fileData[`file_${i}_type`] = null;
  fileData[`file_${i}_path`] = null;
}

  console.log("Files to save:", fileData,formData.adhoc_invoice_details_id);

    const payload = {
      schema_name: 'payments',
      table: 'adhoc_invoice_details',
      set_column : fileData ,
      'where' : [{"id":formData.adhoc_invoice_details_id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        // window.location.reload();
    closePopup();

    // ? unselect row if gridApi available
    if (gridApi) {
      gridApi.deselectAll();
    }
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });

  // TODO: call your API with payload here
  // await axios.post('/your-api-endpoint', payload);
};


const handlePopupInputChange = (name, value) => {
  const updatedData = {
    ...popupData,
    [name]: value,
  };

  console.log("popup data",name, value)

  if (name === 'percentage') {
    const percent = parseFloat(value);
    const base = parseFloat(popupData.purchase_order_amount);
    if (!isNaN(percent) && !isNaN(base)) {
      updatedData.computedValue = ((percent / 100) * base).toFixed(2);
    } else {
      updatedData.computedValue = '';
    }
  }

  setPopupData(updatedData);
};

const closePopup = () => {
  setShowPopup(false);
  if (gridApi) {
      gridApi.deselectAll();
  }
  setPopupData({});
};

  const dropdownSelection = (event) => {
     console.log("selected option",event)
     setSelectedOption(event);
  };


  const fetchFieldInfo2 = async () => {

  const formatted = userCredentials.division.join(",");

    const payload = {
      query: `SELECT 
    ai.id, 
    IFNULL(TRIM(ai.vendor_name), '') AS vendor_name,
    IFNULL(TRIM(ai.vendor_address), '') AS vendor_address,
    IFNULL(TRIM(ai.place_of_supply), '') AS place_of_supply,
    IFNULL(TRIM(ai.invoice_number), '') AS invoice_number,is_transaction_locked,
    IFNULL(DATE_FORMAT(ai.invoice_date, '%d-%m-%Y'), '') AS invoice_date,
    IFNULL(CONVERT(ai.total_invoice_amount, CHAR), '0.00') AS invoice_amount,
    IFNULL(TRIM(ai.purchase_order_number), '') AS purchase_order_number,
    IFNULL(DATE_FORMAT(ai.purchase_order_date, '%d-%m-%Y'), '') AS purchase_order_date,
    IFNULL(TRIM(ai.cost_center_code), '') AS cost_center_code,
    IFNULL(TRIM(ai.approver_mail_id), '') AS approver_mail_id,
    IFNULL(TRIM(ai.expense_code), '') AS expense_code,
    IFNULL(TRIM(ai.expense_category), '') AS expense_category,
    IFNULL(TRIM(ai.sbi_cost_center_code), '') AS sbi_cost_center_code,
    IFNULL(TRIM(ai.sbi_site_code), '') AS sbi_site_code,
    IFNULL(TRIM(ai.site_name), '') AS sbi_site_name,
    IF(ai.sbi_billable = 0, 'NO', 'YES') AS sbi_billable,
    IFNULL(TRIM(ai.invoice_type), '') AS invoice_type,
    IFNULL(TRIM(ai.invoice_status), '') AS invoice_status,pm.adhoc_invoice_details_id,
    CONCAT(IFNULL(TRIM(u.first_name), ''), ' ', IFNULL(TRIM(u.last_name), '')) AS working_person_name
FROM payments.approved_invoices ai
LEFT JOIN payments.users u ON u.id = ai.working_person_id
LEFT JOIN payments.purchase_order_mapped pm ON pm.id = ai.purchase_order_mapped_id
WHERE ai.invoice_number IS NOT NULL 
  AND ai.purchase_order_number IS NOT NULL 
  AND ai.${selectedOption.value} = '${inputValue}' AND ai.invoice_type in (        SELECT name FROM user_management_uat.divisions 
        WHERE division_id IN (${formatted})
)
  AND ai.entity_id = ${userCredentials.selectedentity} 
  AND ai.is_active = 1;
`
    };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;
      if (data && data.length > 0) {
        setRowData(data);
        setShowTable(true);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    editMode ? handleUpdate() : handleCreate();
  };

  const handleCreate = () => {
    const formattedDate = getFormattedDate();
    const updatedFormData = {
      ...formData,
      created_on: formattedDate,
      last_updated_on: formattedDate,
      entity_id: userCredentials.entities_id,
      created_by: userCredentials.user_id,
      modified_by: userCredentials.user_id,
      last_updated_by: userCredentials.user_name,
    };

    const payload = {
      database: 'payments',
      table: 'cost_centres',
      formData: updatedFormData
    };

    const FileUploadCredentials = CreateData();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(() => window.location.reload())
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const handleUpdate = () => {
    const formattedDate = getFormattedDate();
    const updatedFormData = {
      ...formData,
      last_updated_on: formattedDate,
      modified_by: userCredentials.user_id,
      last_updated_by: userCredentials.user_name
    };

    delete updatedFormData.primary_id;

    const payload = {
      schema_name: 'payments',
      table: 'cost_centres',
      set_column: updatedFormData,
      where: [{ id: formData.id }]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(() => {
        setEditMode(false);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onFilterTextChange = (event) => {
    setSearchText(event.target.value);
  };

  if (loading) return <LoaderComponent loaderOpen={true} />;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        ADD ATTACHMENT
      </h2>
<div style={{ display: 'flex', alignItems: 'center', marginLeft: '1em', marginRight: '1em' }}>
<div style={{ width: "15%" }}>
  <label className="label1 mb-1" htmlFor="relationshipNameInput">Type</label> <br />
  <Select
    clearable
    options={optionslist}
    selection
    size="mini"
    onChange={dropdownSelection}
    value={selectedOption}
  />
</div>

<div style={{ width: "15%", marginLeft: "10px" }}>
  <label className="label1 mb-1" htmlFor="valueInput">Value</label> <br />
  <input
    id="valueInput"
    type="text"
    value={inputValue}
    onChange={(e) => setInputValue(e.target.value)}
    style={{
      width: "100%",
      padding: "5px 8px",
      fontSize: "0.875rem",
      backgroundColor: 'white',
      border: "1px solid #ced4da",
      borderRadius: "4px",height:"38px"
    }}
    placeholder="Enter value"
  />
</div>
<div>
<br />
        <button type="submit" className="submit-btn" style={{ width: "90px", height:"33px" }} onClick={fetchFieldInfo2}>
          Search
        </button>
</div>
</div>


      {error && <div style={{ color: "red" }}>{error}</div>}
{showPopup && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "98%",
      height: "95%",
      background: "rgba(0,0,0,0.6)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingLeft:"90px",
      paddingTop:"10px",

    }}
  >
    {/* Inner container */}
    <div
      style={{
        width: "100%",
        height: "100%",
        background: "#fff",
        borderRadius: "0px",
        display: "flex",
        flexDirection: "column",
        padding: "15px",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
        }}
      >
        <h2 style={{ margin: 0, color: "#333" }}>File Manager</h2>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={handleFileSave}
            style={{
              background: "#4969ab",
              color: "white",
              border: "none",
              borderRadius: "6px",
              padding: "6px 15px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Save
          </button>
          <button
            onClick={closePopup}
            style={{
              background: "red",
              color: "white",
              border: "none",
              borderRadius: "6px",
              padding: "6px 12px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            X
          </button>
        </div>
      </div>

      {/* Cards row (scrollable) */}
      <div
        style={{
          display: "flex",
          gap: "12px",
          marginBottom: "15px",
          overflowX: "auto",
          whiteSpace: "nowrap",
          paddingBottom: "5px",
        }}
      >
        {popupData.files?.map((file, index) => (
          <div
            key={index}
            style={{
              minWidth: "130px",
              maxWidth: "130px",
              border: "1px solid #ddd",
              borderRadius: "10px",
              padding: "10px",
              background: "#f9f9f9",
              textAlign: "center",
              position: "relative",
              flexShrink: 0,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                fontWeight: "500",
                color: "#333",
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={file ? file.split("/").pop() : `File ${index + 1}`}
            >
              {file ? file.split("/").pop() : `File ${index + 1}`}
            </span>

            {file ? (
              <>
                <div
                  onClick={() => setSelectedFile(file)}
                  style={{
                    marginTop: "8px",
                    padding: "5px 8px",
                    background: "#007bff",
                    color: "white",
                    borderRadius: "6px",
                    fontSize: "11px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  View
                </div>
                <Icon
                  name="trash"
                  color="red"
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "6px",
                    right: "6px",
                  }}
                  onClick={() => handleDeleteFile(file,index)}
                />
              </>
            ) : (
              <>
                {/* Upload icon */}
                <label
                  htmlFor={`upload-${index}`}
                  style={{
                    display: "inline-block",
                    marginTop: "15px",
                    cursor: "pointer",
                    color: "#4969ab",
                  }}
                >
                  <Icon name="upload" size="large" />
                </label>
                <input
                  id={`upload-${index}`}
                  type="file"
                  style={{ display: "none" }}
                  onChange={(e) =>  handleFileUpload(e, `file_${index + 1}_path`)}
                />
              </>
            )}
          </div>
        ))}
      </div>

      {/* File viewer */}
      <div
        style={{
          flexGrow: 1,
          border: "1px solid #ddd",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        {selectedFile ? (
<FilePreviewer
  fileType="pdf"
  fileUrl={`http://206.1.17.185:1200/api/v2/user_modules/serve-pdf/${selectedFile}`}
/>
        ) : (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#999",
              fontSize: "16px",
            }}
          >
            Select a file to preview
          </div>
        )}
      </div>
    </div>
  </div>
)}

{showTable && (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {(!columnDefs.length || !rowData.length) ? (
          <div>Loading or no data available</div>
        ) : (
          <div
            className="ag-theme-alpine"
            style={{
              overflowX: 'auto',
              overflowY: 'auto',
              borderRadius: '10px',
              width: `${columnDefs.length * 250}px`,
              maxWidth: '100%',
              height: '500px',
              margin: '10px',
              marginTop:'30px'
            }}
          >
            <AgGridReact
              columnDefs={columnDefs}
              rowData={rowData}
              filter={true}
              animateRows={true}
              pagination={true}
              paginationPageSize={10}
              rowSelection={'single'}
              onSelectionChanged={handleCheckboxChange}
              enableCellTextSelection= {true}
              suppressRowClickSelection={true}
              onGridReady={(params) => setGridApi(params.api)}
            />
          </div>
        )}
      </div>
)}
    </div>
  );
}

export default DepartmentCreation;